export const getImageError = state => state.internalStore.company.imageError;
export const getImageState = state => state.internalStore.company.imageState;
